import { dropRight } from 'lodash';
import {
    Corner,
    getNodeAtPath,
    getOtherDirection,
    getPathToCorner,
    MosaicDirection,
    MosaicNode,
    updateTree
} from 'react-mosaic-component';
import { v4 as uuidv4 } from 'uuid';

export const addToTopRight = (layoutNode, moduleToDrop, callback) => {
    let currentNode = layoutNode;
    if (currentNode) {
        const path = getPathToCorner(currentNode, Corner.TOP_RIGHT);
        const parent = getNodeAtPath(currentNode, dropRight(path));
        const destination = getNodeAtPath(currentNode, path);
        const direction: MosaicDirection = parent ? getOtherDirection(parent.direction) : 'row';

        let first;
        let second;
        if (direction === 'row') {
            first = destination;
            second = `${moduleToDrop}-${uuidv4()}`;
        } else {
            first = `${moduleToDrop}-${uuidv4()}`;
            second = destination;
        }

        currentNode = updateTree(currentNode, [
            {
                path,
                spec: {
                    $set: {
                        direction,
                        first,
                        second
                    }
                }
            }
        ]);
    } else {
        currentNode = moduleToDrop;
    }

    callback(currentNode);
};

export function extractLeafIds(node: MosaicNode<string>): string[] {
    if (typeof node === 'string') {
        return [node];
    }

    // node is a MosaicParent
    return [...extractLeafIds(node.first), ...extractLeafIds(node.second)];
}
